import { Link } from 'react-router';

export interface LogoProps {
    homePath?: string;
}

const Logo = ({ homePath = '/' }: LogoProps) => {
    const url = new URL('@/public/icons/favicon.png', import.meta.url).href;

    return (
        <Link to={homePath}>
            <img alt="logo" className="mx-auto h-8 w-auto object-contain" src={url} />
        </Link>
    );
};

export default Logo;
